'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:storage:getItem');
}

var _invoke = require('../invoke');

/**
 * 客户端存储／查
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof storage
 * @static
 * @name getItem
 * @return {Promise<val>}
 * @example
 *  hbnb.storage.getItem('key')
 *      .then(function(value) {
 *          value = '' || null;
 *      });
 */
module.exports = function(key) {
    if (process.env.NODE_ENV !== 'production') {
        debug('key is %s', key);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('storage', 'get_item', {
            key: key,
            callback: function(val) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('value is %j', val);
                }

                if (val && val.value) {
                    resolve(val.value);
                } else {
                    resolve(null);
                }
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/storage/get-item.js
// module id = 615
// module chunks = 0